<template>
  <v-sheet v-if="!isHiddenHeader" class="header-container" elevation="0">
    <!-- 디테일 페이지인 경우 뒤로가기 버튼 -->
    <div v-if="isDetailPage" class="back-button-wrapper">
      <button type="button" class="header-icon-button" aria-label="뒤로 가기" @click="backBtnClick()">
        <v-icon size="25" color="grey darken-4"> mdi-arrow-left </v-icon>
      </button>
    </div>

    <!-- 메인 페이지인 경우 기본 헤더 요소들 -->
    <template v-else>
      <!-- 언어 선택 컴포넌트 -->
      <div class="language-select-wrapper">
        <LanguageSelectComponentVue />
      </div>

      <!-- 로고 -->
      <div class="logo-wrapper" v-if="!isIndividual">
        <v-img class="header-logo" width="112" height="20" contain :src="require('@/assets/logo/logo-title.webp')" @click="link('/')"></v-img>
      </div>

      <!-- 계정 -->
      <div class="account-wrapper">
        <button v-if="!isLoggedIn" type="button" class="header-icon-button" aria-label="로그인" @click="loginWithQuery()">
          <v-icon size="25" color="grey darken-4"> mdi-account-circle-outline </v-icon>
        </button>

        <div v-if="isLoggedIn" class="account-menu-shell">
          <button
            type="button"
            class="header-icon-button"
            aria-label="계정 메뉴"
            aria-haspopup="menu"
            :aria-expanded="isAccountMenuOpen"
            @click.stop="toggleAccountMenu()"
          >
            <img class="rounded-circle profile-image" :src="currentUserProfileImage" alt="" />
          </button>
          <div
            v-if="isAccountMenuOpen"
            class="account-menu-backdrop"
            aria-hidden="true"
            @click="closeAccountMenu()"
          ></div>
          <div v-if="isAccountMenuOpen" class="account-menu-panel" role="menu" @click.stop>
            <button type="button" class="account-menu-item" role="menuitem" @click="goToAccountPage('/mypage/setting')">
              <v-icon size="19">mdi-account-cog-outline</v-icon>
              <span>내 정보</span>
            </button>
            <button type="button" class="account-menu-item" role="menuitem" @click="goToAccountPage('/mypage/home')">
              <v-icon size="19">mdi-view-dashboard-outline</v-icon>
              <span>촬영/예약 내역</span>
            </button>
          </div>
        </div>
      </div>
    </template>

    <!-- 메뉴 -->
    <!-- <v-icon size="32" color="grey darken-4" @click.stop="menuBtnClick()"> {{ isMenu ? "mdi-menu" : "mdi-arrow-left" }} </v-icon> -->

    <!-- 사이드바 -->
    <!-- <v-navigation-drawer v-model="drawer" height="100vh" absolute temporary>
      <v-list nav class="mt-16">
        <v-list-item-group v-model="group">
          <v-list-item>
            <v-list-item-title @click="link('/')">
              <span class="font-weight-medium">{{ $t("sidemenu.main") }}</span>
            </v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title @click="link('/location')">
              <span class="font-weight-medium">{{ $t("sidemenu.location") }}</span>
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-divider class="mt-6 mb-2 mx-2"></v-divider>
      <LanguageSelectComponentVue />
      
      <div :class="['logo', { 'mobile-bottom': $vuetify.breakpoint.mobile }]">
        <v-img class="mt-6 mx-auto" width="55%" src="@/assets/logo/main.svg"></v-img>
        <p class="mt-2 grey--text px-4 text-caption text-center">ver {{ appVer }}</p>
      </div>
    </v-navigation-drawer> -->
  </v-sheet>
</template>
<script>
import LanguageSelectComponentVue from "@/components/LanguageSelectComponent.vue"
import { mapState, mapGetters, mapMutations, mapActions } from "vuex"

import { AppVersion, isMenuPage } from "../../constant"

export default {
  components: {
    LanguageSelectComponentVue,
  },
  data: () => ({
    drawer: false,
    group: null,

    appVer: AppVersion,
    isIndividual: false,
    isAccountMenuOpen: false,
  }),
  computed: {
    ...mapState(["lafia_user"]),
    ...mapGetters(["lafiaUser_profile_img_path", "jwtUserProfileImagePath"]),

    path() {
      return this.$route.path
    },
    isDetailPage() {
      return !isMenuPage(this.$route.path)
    },
    // 헤더를 숨길 페이지 목록
    isHiddenHeader() {
      const hiddenPages = ["/website_youtube_link"]
      return hiddenPages.includes(this.$route.path)
    },
    // 로그인 상태 확인 (lafia_user 기반)
    isLoggedIn() {
      return this.lafia_user.is_logined
    },
    // 사용자 프로필 이미지 (lafia_user 기반)
    currentUserProfileImage() {
      return this.jwtUserProfileImagePath || this.lafiaUser_profile_img_path
    },
  },

  methods: {
    ...mapActions(["getPromotionPrice"]),

    toggleAccountMenu() {
      this.isAccountMenuOpen = !this.isAccountMenuOpen
    },
    closeAccountMenu() {
      this.isAccountMenuOpen = false
    },
    handleAccountMenuKeydown(event) {
      if (event.key === "Escape") {
        this.closeAccountMenu()
      }
    },
    goToAccountPage(url) {
      this.closeAccountMenu()
      this.link(url)
    },
    link(url) {
      if (this.$route.path != url) {
        this.$router.push(url)
      }
    },
    loginWithQuery() {
      console.log("loginWithQuery", this.$route.query)
      const currentQuery = this.$route.query
      this.$router.push({
        path: "/auth/login",
        query: currentQuery,
      })
    },
    backBtnClick() {
      console.log("history.length", window.history.length)
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.replace("/")
      }
    },
  },

  async mounted() {
    document.addEventListener("click", this.closeAccountMenu)
    document.addEventListener("keydown", this.handleAccountMenuKeydown)

    if (this.$route.query.event) {
      const promotionCode = this.$route.query.event
      const res = await this.getPromotionPrice({ promotionCode: promotionCode })
      this.isIndividual = res != null && res.promotionPrice != null && res.promotionPrice.isIndividual
    }
  },

  beforeDestroy() {
    document.removeEventListener("click", this.closeAccountMenu)
    document.removeEventListener("keydown", this.handleAccountMenuKeydown)
  },
}
</script>
<style scoped>
.v-btn::before {
  background-color: white !important;
}
.logo {
  position: fixed;
  width: 100%;
  bottom: 70px;
}
.mobile-bottom {
  bottom: 120px;
}
.v-navigation-drawer {
  z-index: 9999 !important;
}
.header-container {
  position: fixed;
  top: calc(6px + env(safe-area-inset-top));
  left: 50%;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% - 24px);
  max-width: 556px;
  min-height: 40px;
  padding: 0 8px;
  overflow: visible;
  background: transparent !important;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  transform: translateX(-50%);
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}
.language-select-wrapper {
  position: absolute;
  left: 2px;
  min-width: 28px;
  padding: 1px 5px;
  background: rgba(255, 255, 255, 0.46);
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-radius: 999px;
  box-shadow: 0 2px 9px rgba(67, 47, 57, 0.07);
}
.logo-wrapper {
  margin: 0 auto;
  text-align: center;
}
.header-logo {
  cursor: pointer;
  filter: drop-shadow(0 1px 2px rgba(255, 255, 255, 0.74));
}
.account-wrapper {
  position: absolute;
  right: 1px;
}
.account-menu-shell {
  position: relative;
}
.account-menu-shell > .header-icon-button {
  position: relative;
  z-index: 1002;
}
.account-menu-backdrop {
  position: absolute;
  top: -100vh;
  right: -100vw;
  width: 200vw;
  height: 200vh;
  z-index: 1000;
  background: transparent;
}
.account-menu-panel {
  position: absolute;
  top: calc(100% + 7px);
  right: 0;
  z-index: 1001;
  width: 164px;
  padding: 5px;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid rgba(215, 187, 194, 0.72);
  border-radius: 14px;
  box-shadow: 0 12px 30px rgba(67, 47, 57, 0.16);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
}
.account-menu-item {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 42px;
  padding: 0 10px;
  color: #4f4448;
  font-size: 13px;
  font-weight: 600;
  text-align: left;
  background: transparent;
  border: 0;
  border-radius: 10px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.account-menu-item + .account-menu-item {
  margin-top: 2px;
}
.account-menu-item .v-icon {
  margin-right: 8px;
  color: #786a70;
}
.account-menu-item span {
  white-space: nowrap;
}
.account-menu-item:active {
  background: rgba(241, 218, 225, 0.64);
}
.account-menu-item:focus-visible {
  outline: 2px solid rgba(211, 72, 122, 0.42);
  outline-offset: -2px;
}
.back-button-wrapper {
  position: absolute;
  left: 1px;
}
.header-icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  color: inherit;
  background: rgba(255, 255, 255, 0.54);
  border: 1px solid rgba(255, 255, 255, 0.82);
  border-radius: 50%;
  box-shadow: 0 2px 10px rgba(67, 47, 57, 0.1);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}
.header-icon-button .v-icon,
.header-icon-button .v-image {
  filter: none;
}
.header-icon-button:active {
  background: rgba(255, 255, 255, 0.82);
  transform: scale(0.96);
}
.header-icon-button:focus-visible {
  outline: 2px solid rgba(211, 72, 122, 0.48);
  outline-offset: 1px;
}
.profile-image {
  display: block;
  flex: none;
  width: 32px;
  height: 32px;
  object-fit: cover;
}
::v-deep .language-select-wrapper > .v-sheet {
  gap: 7px !important;
  margin: 0 !important;
  padding: 0 !important;
  background: transparent !important;
}
::v-deep .language-select-wrapper .v-btn {
  min-width: auto !important;
  height: 22px !important;
  padding: 0 1px !important;
  color: #6d6468 !important;
  font-size: 9px !important;
  font-weight: 400 !important;
  background: transparent !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  text-shadow:
    0 1px 0 rgba(255, 255, 255, 0.9),
    0 0 6px rgba(255, 255, 255, 0.95);
}
::v-deep .language-select-wrapper .v-btn[style*="background-color"] {
  color: #d3487a !important;
  font-weight: 700 !important;
}
::v-deep .language-select-wrapper .v-btn::before {
  opacity: 0 !important;
}
@media (max-width: 360px) {
  .header-container {
    width: calc(100% - 18px);
    padding: 0 5px;
  }
  .header-logo {
    width: 96px !important;
  }
}
@media (prefers-reduced-motion: reduce) {
  .header-icon-button:active {
    transform: none;
  }
}
</style>
